import $ from 'jquery/src/jquery';
import { Swiper } from 'swiper';
import {Navigation, Pagination, Thumbs} from "swiper/modules";
Swiper.use([Navigation, Pagination, Thumbs]);

export default () => {
    const nodeSelectors = {
        container: '[js-videoReview="container"]',
        play: '[js-videoReview="play-button"]',
        close: '[js-videoReview="close"]'
    }

    function init() {
        if (!document.querySelector(nodeSelectors.container)) {
            return
        }

        initVideoReview()
    }

    function initVideoReview() {

        $(nodeSelectors.play).on('click', function(){
            let currentVideo = $(this).data('video');
            // $(this).fadeOut();
            // $(this).parent().find(' img,  .overlay').fadeOut();
            // $(this).parent().find(' iframe').attr('src', currentVideo)
            $('.video-popup').fadeIn();
            $('.video-popup iframe').attr('src', currentVideo)
        })

        $(nodeSelectors.close).on('click', function(){
            $('.video-popup').fadeOut();
            $('.video-popup iframe').attr('src', '')
        })

        
    }

    return Object.freeze({
        init,
    })
}